import React from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { cn } from "./cn";

export default function Pagination({ page = 1, totalPages = 1, onChange, summary, className }) {
  const go = (p) => p >= 1 && p <= totalPages && p !== page && onChange?.(p);

  // Compact window: 1 … (page-1) page (page+1) … last
  const pages = [];
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || (p >= page - 1 && p <= page + 1)) pages.push(p);
    else if (pages[pages.length - 1] !== "…") pages.push("…");
  }

  if (totalPages <= 1 && !summary) return null;

  return (
    <div className={cn("flex flex-col items-center justify-between gap-3 sm:flex-row", className)}>
      {summary ? <p className="text-sm text-muted">{summary}</p> : <span className="hidden sm:block" />}
      <div className="flex items-center gap-1">
        <button
          onClick={() => go(page - 1)}
          disabled={page <= 1}
          className="grid h-9 w-9 place-items-center rounded-lg border border-line text-muted transition hover:bg-surface-2 hover:text-ink disabled:pointer-events-none disabled:opacity-40"
          aria-label="Previous page"
        >
          <CaretLeft size={15} weight="bold" />
        </button>
        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="px-1.5 text-sm text-faint">
              …
            </span>
          ) : (
            <button
              key={p}
              onClick={() => go(p)}
              className={cn(
                "h-9 min-w-[2.25rem] rounded-lg border px-3 text-sm transition",
                p === page
                  ? "border-accent bg-accent text-accent-fg"
                  : "border-line text-ink hover:bg-surface-2"
              )}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={() => go(page + 1)}
          disabled={page >= totalPages}
          className="grid h-9 w-9 place-items-center rounded-lg border border-line text-muted transition hover:bg-surface-2 hover:text-ink disabled:pointer-events-none disabled:opacity-40"
          aria-label="Next page"
        >
          <CaretRight size={15} weight="bold" />
        </button>
      </div>
    </div>
  );
}
